'use client';
import Link from 'next/link';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y, Autoplay } from 'swiper/modules';

// Swiper 기본 스타일
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function MainCarousel({ carouselInfo }) {
  const router = useRouter();

  const pathName = carouselInfo?.[0]?.id === 'n1' ? 'news' : 'gallery';

  const goToPromotionDetailPage = (id) => {
    router.push(`/${pathName}/${id}`);
  };

  return (
    <div className="relative w-full">
      <Swiper
        modules={[Navigation, Pagination, A11y, Autoplay]}
        loop
        navigation={{
          prevEl: '.swiper-button-prev-custom',
          nextEl: '.swiper-button-next-custom',
        }}
        pagination={{
          clickable: true,
          renderBullet: function (index, className) {
            return `<span class="${className} !bg-blue-600 !w-3 !h-3"></span>`;
          },
        }}
        autoplay={{
          delay: 4000,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
        }}
        spaceBetween={24}
        breakpoints={{
          0: { slidesPerView: 1.1 },
          640: { slidesPerView: 1.5 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 2.5 },
          1280: { slidesPerView: 3 },
        }}
        grabCursor={true}
        className="!pb-12"
      >
        {carouselInfo.map((info, index) => (
          <SwiperSlide key={info.id}>
            <div
              className="group max-w-sm mx-auto cursor-pointer transform transition-transform duration-300 hover:scale-[1.02]"
              onClick={() => goToPromotionDetailPage(info.id)}
            >
              {/* 메인 카드 */}
              <div className="bg-blue-100/10  backdrop-blur-xs hover:bg-blue-600 transition-colors duration-300 shadow-sm hover:shadow-lg border overflow-hidden">
                {/* 이미지 영역 */}
                <div className="relative h-48 overflow-hidden">
                  <Image
                    src={info.thumnail}
                    alt={info.title}
                    fill
                    sizes="(min-width:1280px) 25vw, (min-width:1024px) 30vw, (min-width:768px) 50vw, 80vw"
                    className="object-cover transition-transform duration-300 group-hover:scale-105"
                    priority={index < 3}
                  />

                  {/* 카테고리 배지 */}
                  <div className="absolute top-3 left-3">
                    <span className="inline-flex px-3 py-1 text-xs font-medium text-white bg-blue-600 rounded-full">
                      {pathName === 'news' ? 'NEWS' : 'GALLERY'}
                    </span>
                  </div>
                </div>

                {/* 콘텐츠 영역 */}
                <div className="p-5">
                  <h5 className="mb-2 text-lg font-semibold text-gray-100 line-clamp-2 group-hover:text-white transition-colors duration-300">
                    {info.title}
                  </h5>

                  {info.date && (
                    <div className="flex items-center text-sm text-gray-100 group-hover:text-white transition-colors duration-300 mb-3">
                      <svg
                        className="w-4 h-4 mr-1.5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.5"
                          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                        />
                      </svg>
                      {info.date}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
